import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Success">
                            <h2>Ensure Your Product’s Usefulness, Ensure Your Success</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Building a digital product is not a more significant challenge than knowing whether a digital product is helpful for the market. At TekRevol, we take this beyond a few sheets of paper to experiment.</p>
                       <p>With our lean startup service, we aim to maximize the impact that your startup should. So that, by the time it nears completion, it is already more productive and useful than others in the market.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;